// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"1c6e37eb","239":"2744bb78","453":"b46aa61f","455":"2471567b","833":"f6b394c5","977":"b5ff5b24"}[chunkId] + ".chunk.js";
};